import React from "react";
import { Card, Statistic } from "antd";
import {
  ShoppingCartOutlined,
  CarOutlined,
  DollarCircleOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

const iconMap = {
  orders: <ShoppingCartOutlined style={{ fontSize: 28 }} />,
  cars: <CarOutlined style={{ fontSize: 28 }} />,
  revenue: <DollarCircleOutlined style={{ fontSize: 28 }} />,
  addons: <AppstoreOutlined style={{ fontSize: 28 }} />,
};

const colorMap = {
  orders: "linear-gradient(135deg, #1677ff, #69b1ff)",
  cars: "linear-gradient(135deg, #52c41a, #95de64)",
  revenue: "linear-gradient(135deg, #fa541c, #ff9c6e)",
  addons: "linear-gradient(135deg, #722ed1, #b37feb)",
};

const StatCard = ({ title, value, type }) => {
  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 16,
        background: colorMap[type],
        color: "#fff",
        boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
        height: 120,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <p style={{ fontSize: 14, opacity: 0.9 }}>{title}</p>
          <h2 style={{ margin: 0, fontWeight: 700 }}>{value}</h2>
        </div>
        <div style={{ opacity: 0.9 }}>{iconMap[type]}</div>
      </div>
    </Card>
  );
};

export default StatCard;
